#import "../../../../../../core-entity/graphql/fragments/account-for-core-entity-fragment.graphql"

fragment AccountHierarchyInfoFragment on Account {
    ...AccountForCoreEntityFragment
    parentAccount {
        ...AccountForCoreEntityFragment
    }
    childAccounts(first: 1000) {
        totalCount
        edges {
            node {
                ...AccountForCoreEntityFragment
            }
        }
    }
}
